import { useTranslation } from 'react-i18next';

import { Input } from 'libs/ui';
import { Content } from './find.styled';

export const ReceiptFind = (props) => {
  const { value, onChange } = props;
  const { t } = useTranslation();

  const change = (event) => {
    const val = event.target.value;
    onChange(val.trim());
  };

  return (
    <Content>
      <Input className="size-sm" type="text" value={value} onChange={change} placeholder={t('filters.Поиск шаблона')} />
    </Content>
  );
};
